// extracted by mini-css-extract-plugin
export default {"inputContainer":"ChatInput_inputContainer__1RDfJ"};